import React, { useState, useEffect } from "react";

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Form,
    Container,
    Row,
    Col,
    Spinner
} from "reactstrap";
// core components
import Header from "../../../../components/Headers/BasicHeader";
import { useNavigate, useParams } from "react-router-dom";
import { getSubscription, postSubscription, putSubscription } from "network/ApiAxios";
import AccountInformation from "./AccountInformation";
import SubscriptionInformation from "./SubscriptionInformation";
import BasicModal from '../../../../components/Modals/BasicModal'

const Profile = (props) => {

    const navigate = useNavigate();
    const params = useParams()
    const [subscription, setSubscription] = useState({});
    const formDisabled = (props.action == "view")
    const [showModal, setShowModal] = useState(false)
    const [modalMessage, setModalMessage] = useState("")
    const [modalTitle, setModalTitle] = useState()
    const [modalGoTo, setModalGoTo] = useState()
    const [isLoading, setisLoading] = useState(false)
    const validations = {}

    useEffect(() => {

        const runAsync = async () => {
            const response = await getSubscription(params.id);
            const { data } = response;

            if (data.success) {
                setSubscription(data.subscription);
            } else {
                setModalTitle("Error")
                setModalMessage(data.msg)
                setShowModal(true)
            }
        }

        runAsync();

    }, []);

    return (
        <>
            <Header />

            <Container className="border-0 pb-0 pt-0 pt-md-3" fluid>
                <Row>

                    <Col className="order-xl-1" >
                        <Card className=" shadow">
                            <CardHeader className="bg-white border-0">
                                <Row className="align-items-center">
                                    <Col xs="8" className="text-left">
                                        <Button onClick={() => navigate('/admin/subscriptions')}
                                            className="btn-back" type="button">

                                            <span className="btn-inner--icon">
                                                <i className="ni ni-bold-left" />
                                            </span>

                                            <span className="btn-inner--text h3 mb-0">Subscription's Profile</span>

                                        </Button>

                                    </Col>

                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Form>

                                    <SubscriptionInformation
                                        subscription={subscription}
                                        formDisabled={formDisabled || isLoading}
                                        setSubscription={setSubscription}
                                        validations={validations} />

                                    <hr className="my-4" />                                    

                                    <AccountInformation
                                        subscription={subscription}
                                        formDisabled={true} />

                                    <hr className="my-4" />

                                    <Row className="align-items-left">
                                        <Col className="text-left" xs="4">

                                            <Button onClick={() => navigate('/admin/subscriptions')}
                                                className="btn-icon btn-3" color="primary" type="button">

                                                <span className="btn-inner--icon">
                                                    <i className="ni ni-bold-left" />
                                                </span>

                                                <span className="btn-inner--text">Back</span>

                                            </Button>

                                        </Col>



                                    </Row>

                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <BasicModal
                title={modalTitle}
                message={modalMessage}
                showModal={showModal}
                setShowModal={setShowModal}
                handleGoTo={modalGoTo} />
        </>
    );
}

export default Profile;
